import { Injectable } from '@angular/core';
import { DefaultService, NextGenNode, BaseResponseDTO } from '@psnb/psnb-api';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class NextGenNodeService {

  constructor(private powerSupplyService: DefaultService) { 
  }

  getAllNextGenNodes() {
    return this.powerSupplyService.getNextGenNodes().pipe(map(result => result));
  }

  createNextGenNode(jsonNextGenNode: NextGenNode) {
    return this.powerSupplyService.createNextGenNode(jsonNextGenNode).pipe(map(result => result));
  }

  deleteNextGenNode(id: number): Observable<BaseResponseDTO> {
    return this.powerSupplyService.deleteNextGenNode(id).pipe(map(result => result));
  }

  updateNextGenNode(jsonNextGenNode: NextGenNode) {
    return this.powerSupplyService.updateNextGenNode(jsonNextGenNode).pipe(map(result => result));
  }
}
